import React from 'react';
import { ClipboardListIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
const HowItWorks: React.FC = () => {
  const steps = [{
    icon: <ClipboardListIcon className="w-10 h-10 text-[#0EB7FF]" data-id="element-103" />,
    title: 'Svara på 9-12 snabba frågor',
    description: 'Enkla frågor om din sexuella hälsa och prestationsförmåga – helt anonymt.'
  }, {
    icon: <UserIcon className="w-10 h-10 text-[#0EB7FF]" data-id="element-104" />,
    title: 'Få en personlig profil + plan',
    description: 'Baserad på forskning och anpassad efter dina behov.'
  }, {
    icon: <ArrowRightIcon className="w-10 h-10 text-[#0EB7FF]" data-id="element-105" />,
    title: 'Upptäck personliga lösningar',
    description: 'Få tillgång till skräddarsydda rekommendationer för bättre sexuell hälsa.'
  }];
  return <section className="w-full py-16 px-4 bg-[#0A1020]" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-108">
          Hur funkar det?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-109">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center p-6 bg-gray-900 bg-opacity-40 rounded-lg" data-id="element-110">
              <div className="mb-4" data-id="element-111">{step.icon}</div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-112">{step.title}</h3>
              <p className="text-gray-300" data-id="element-113">{step.description}</p>
              {index < steps.length - 1 && <div className="hidden md:block absolute right-0 top-1/2 transform -translate-y-1/2 -translate-x-1/2" data-id="element-114">
                  <ArrowRightIcon className="w-6 h-6 text-gray-600" data-id="element-115" />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};
export default HowItWorks;